import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { GroupDto } from '../../dto/GroupDto';
import { IApiParams } from '../../interface/IApiParams';
import { getApi } from '../getApi';

export const apiDeleteGroup = async (dto: GroupDto) => {
  const params: IApiParams = {
    url: '/group/deleteGroup.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'DELETE', dto);
};
